import React from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function FormInformationFail() {
  const navigate = useNavigate();

  return (
    <MKBox component="section" py={{ xs: 6, sm: 12 }}>
      <Container>
        <Grid container item xs={12} justifyContent="center">
          <Grid container justifyContent="center" py={2} spacing={1}>
            <MKTypography variant="subtitle2" fontWeight="medium" color="primary">
              ขออภัยธนาคารไม่พบข้อมูลของท่าน จึงไม่สามารถเข้าร่วมโครงการได้
            </MKTypography>
          </Grid>
          <Grid container justifyContent="center" py={2}>
            <MKButton variant="contained" color="primary" onClick={() => navigate("/ndrs/consent")}>
              กลับหน้าแรก
            </MKButton>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FormInformationFail;
